
import { useId, type ReactNode } from "react";

import { cn } from "./cn";
import styles from "./PageHeader.module.css";
import { usePageTitle } from "./shell";

export type PageWidth = "narrow" | "default" | "full";

export type PageProps = {
  width?: PageWidth;
  fullHeight?: boolean;
  labelledBy?: string;
  className?: string;
  children: ReactNode;
};

export function Page({ width = "default", fullHeight, labelledBy, className, children }: PageProps) {
  return (
    <section
      className={cn(styles.page, className)}
      data-page-width={width === "default" ? undefined : width}
      data-full-height-page={fullHeight ? "" : undefined}
      aria-labelledby={labelledBy}
    >
      {children}
    </section>
  );
}

export type PageHeaderProps = {
  title: string;
  documentTitle?: string;
  description?: ReactNode;
  meta?: ReactNode;
  actions?: ReactNode;
  tabs?: ReactNode;
  titleId?: string;
  className?: string;
};

export function PageHeader({
  title,
  documentTitle,
  description,
  meta,
  actions,
  tabs,
  titleId,
  className,
}: PageHeaderProps) {
  const generatedId = useId();
  usePageTitle(documentTitle ?? title);

  return (
    <div className={cn(styles.header, className)}>
      <div className={styles.headerTop}>
        <div className={styles.headerCopy}>
          <h1 className={styles.title} id={titleId ?? generatedId}>
            {title}
          </h1>
          {description ? <p className={styles.description}>{description}</p> : null}
          {meta ? <div className={styles.meta}>{meta}</div> : null}
        </div>
        {actions ? <div className={styles.actions}>{actions}</div> : null}
      </div>
      {tabs ? <div className={styles.tabs}>{tabs}</div> : null}
    </div>
  );
}
